import { useApolloClientRefetch } from '@pay-bill/hooks/use-apollo-refetcher';
import { useCallback } from 'react';

export const useDisputeRefetchs = () => {
  const refetchQueries = useApolloClientRefetch();

  return useCallback(() => {
    refetchQueries([
      // We might have filters related to disputes
      'PaginatedDisputesList',
      'PaginatedInvItemsList',
      // We have counts related to disputes
      'PaginatedReverseInvoicesList',
      'PaginatedInvoicesQuery',
    ]);
  }, [refetchQueries]);
};
